<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table
      [name]="name"
      [endpoint]="'/evaluations/tables'"
      [hasChartView]="false"
      [onRowClick]="openUserEvaluation"
    ></app-api-table>
  }
</app-tab-layout>
<app-modal
  [title]="repName"
  size="xl"
  [opened]="isModalOpen()"
  (closeTrigger)="onModalClose()"
>
  <div class="modal-content">
    <div class="average-container">
      <p class="head">{{ dictionaryService.get('AverageScores') }}</p>
      <app-radar-chart
        [data]="totalData"
        [title]="dictionaryService.get('AverageScores')"
        [chartTitle]="dictionaryService.get('EvaluationDetails')"
        [height]="320"
      ></app-radar-chart>
    </div>
    <app-rep-dates-analytics [repData]="repData" />
  </div>
</app-modal>
